module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_down.2cc14b92.svg";